<template>
  <div class="card-actions">
    <button
      class="expandAction"
      @click="show = !show"
    ><ion-icon name="ellipsis-vertical-outline"></ion-icon></button>

    <div class="actions" :class="{ '-show': show }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardActions',

  data() {
    return {
      show: false,
    };
  },

  methods: {
    /**
     * Check if element are inside a card-actions component.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreInsideCardActions(el) {
      try {
        let node = el.parentNode;

        while (node != null) {
          if ((node.className || '').indexOf('card-actions') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },
  },

  mounted() {
    document.addEventListener('click', ({ target }) => {
      const elementAreInsideCardActions = this.elementAreInsideCardActions(target);

      if (this.show && !elementAreInsideCardActions) {
        this.show = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  .card-actions {
    @apply flex;
    @apply items-center;
    @apply justify-end;
    @apply relative;
    @apply ml-auto;
    white-space: nowrap;

    > .expandAction {
      @apply flex;
      @apply text-xl;
      outline: none;

      @screen md {
        display: none;
      }
    }

    > .actions {
      width: 230px;
      position: absolute;
      z-index: 12;
      top: 100%;
      right: 0;
      background: #fff;
      box-shadow: 0px 3px 6px rgba(89, 102, 122, 0.3);
      border-color: #e2e8f0;
      box-sizing: border-box;
      display: none;
      border-radius: 4px;
      flex-wrap: wrap;
      padding: 10px;
      justify-content: flex-start;

      &.-show {
        @apply flex;
      }

      @screen md {
        width: auto;
        min-width: 0;
        padding: 0;
        @apply flex;
        position: initial;
        background: transparent;
        box-shadow: none;
      }
    }
}
</style>
